(function() {
            const savedTheme = localStorage.getItem('theme');
            const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

            // Kiểm tra: Nếu đã lưu 'dark' HOẶC (chưa chọn gì nhưng hệ thống đang bật dark mode)
            if (savedTheme === 'dark' || (!savedTheme && systemPrefersDark)) {
                document.documentElement.classList.add('dark-mode');
            }
        })();
        
const toggleButton = document.getElementById('dark-mode-toggle');
const toggleButtonMobile = document.getElementById('dark-mode-toggle-mobile');

// Hàm bật/tắt dark mode
function toggleDarkMode() {
    const isDark = document.documentElement.classList.toggle('dark-mode');
    // Lưu lựa chọn thủ công của người dùng
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
}

// Gán sự kiện click cho cả 2 nút
if (toggleButton) toggleButton.addEventListener('click', toggleDarkMode);
if (toggleButtonMobile) toggleButtonMobile.addEventListener('click', toggleDarkMode);

// Lắng nghe nếu người dùng đổi giao diện hệ thống (OS) và CHƯA từng chọn thủ công
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    const savedTheme = localStorage.getItem('theme');
    if (!savedTheme) {
        if (e.matches) {
            document.documentElement.classList.add('dark-mode');
        } else {
            document.documentElement.classList.remove('dark-mode');
        }
    }
});